// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"662dcc26","160":"65710bf4","208":"dde523ea","293":"6c8a5662","453":"d80e1568","516":"707e20c5","519":"aedefa55","917":"e25d8176","946":"7fd97222"}[chunkId] + ".chunk.js";
};